           import {
  CREATE_PAYMENT_NEW_RECORD,
  CREATE_PAYMENT_NEW_RECORD_SUCCESS,
  CREATE_PAYMENT_NEW_RECORD_ERROR,  

  SET_RECORD_TYPE,
  PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
  PANEL_NEW_RECORD_HIDE_CLICK,
  UPDATE_NEW_RECORD_STATE,

  GET_PAYMENTMETHOD_RECORDS,
  GET_PAYMENTMETHOD_RECORDS_SUCCESS,
  GET_PAYMENTMETHOD_RECORDS_ERROR

} from "../actions";

export const getRecords = (recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount, profile, params, searchInputName) => ({
  type: GET_PAYMENTMETHOD_RECORDS,
  payload: { recordType, pageNumber, displayStatus, parentRecordId, selectedFilters, vocabularyId, hasUserAccount, profile, params, searchInputName },
});

export const getRecordsSuccess = (recordList) => ({
  type: GET_PAYMENTMETHOD_RECORDS_SUCCESS,
  payload: recordList,
});

export const getRecordsError = (message) => ({
  type: GET_PAYMENTMETHOD_RECORDS_ERROR,
  payload: { message },
});

export const createPaymentItemNewRecord = (newRecord, history, selectedFilters) => ({
    type: CREATE_PAYMENT_NEW_RECORD,
    payload: {newRecord, history, selectedFilters}
  });

export const createPaymentItemNewRecordSuccess = (recordCreated) => ({
  type: CREATE_PAYMENT_NEW_RECORD_SUCCESS,
  payload: recordCreated,
});

export const createPaymentItemNewRecordError = (message) => ({
  type: CREATE_PAYMENT_NEW_RECORD_ERROR,
  payload: { message },
});


export const hideNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_HIDE_CLICK,
    payload: {},
  });

export const toggleNewRecordPanel = () => ({
    type: PANEL_NEW_RECORD_SHOW_HIDE_CLICK,
    payload: {},
  });

export const setRecordType = (recordTypeSelected) => ({
    type: SET_RECORD_TYPE,
    payload: {recordTypeSelected},
  });

export const updateNewRecordState = (updatedValues) => ({
  type: UPDATE_NEW_RECORD_STATE,
  payload: { updatedValues }
});